export enum CalendarRRuleBehavior {
    AddDates = 0,
    RemoveDates
}
